type ClassValue = string | number | boolean | null | undefined | Record<string, any> | ClassValue[];

/** clsx (custom): simple implementation of https://www.npmjs.com/package/clsx */
export function clsxc(...values: ClassValue[]): string {
  const classes: string[] = [];

  const handle = (val: ClassValue) => {
    if (!val && val !== 0) return;
    if (typeof val === "string" || typeof val === "number") {
      classes.push(String(val));
      return;
    }
    if (Array.isArray(val)) {
      val.forEach(handle);
      return;
    }
    if (typeof val === "object") {
      for (const key in val as Record<string, any>) {
        if (Object.prototype.hasOwnProperty.call(val, key) && (val as Record<string, any>)[key]) {
          classes.push(key);
        }
      }
    }
  };

  values.forEach(handle);
  return classes.join(" ");
}
